<template>
  <nav-group>

    <div v-for="link in links" :key="link.name">
      <div v-if="(link.isDev && $isDev) || link.isDev === undefined" :class="link.isDev ? 'isDev' : ''">
        <h5 v-if="link.isTitle" class="nav-group-title">
          <span>{{link.title}}</span>
          </h5>
        <hr v-else-if="link.isHR"/>
        <router-link v-else tag="a" :to="link.to">
          <nav-item :class="selectionClass(link.class ? link.class : link.name)">{{link.name}}</nav-item>
        </router-link>
      </div>
    </div>

  </nav-group>
  
</template>

<script>
export default {
  data: function () {
    return {
      count: 0,
      navSelection : '',
      links: [
        {title:"ℹ️ Information", isTitle:true},
        {name:"Intro", to:"/"},
        
        // {isHR: true},
        // {title:"⌨️ Data Entry", isTitle:true},
        // {isDev:true, name:"ShiftReconciliation", to:"/DataEntry/ShiftReconciliation"},
        
        // {isHR: true},
        // {title:"⚡Live Data", isTitle:true},
        // {name:"Latest Sales", to:"/LiveData/LatestSales"},
        // {name:"Pump Status", to:"/LiveData/PumpStatusPage"},
        //🌟⭐
        // {isHR: true},
        // {title:" Reports", isTitle:true},
        // {name:"Location Sales Comparison", to:"/Reports/LocationSalesComparison"},
        // {name:"Location Summary", to:"/Reports/LocationSummary"},
        // {name:"Location Top Sales", to:"/Reports/LocationTopSales"},
        // {name:"Location Top Cig Sales", to:"/Reports/LocationTopCigSales"},
        
        {title:" Reports", isTitle:true},
        {isHR: true},
        {name:"Fuel Summary", to:"/Reports/Fuel/FuelSummaryReport"},
        {name:"PAP Credit vs Debit", to:"/Reports/Fuel/PAPCreditVsDebit"},
        {name:"Reconcilliation Report", to:"/Reports/Reconcilliation/ReconcilliationReport"},
        // {name:"Cashiers Report", to:"/Reports/Cashiers/CashiersReport"},
        
        // {isDev:true, name:"Location Cig Top Sales", to:"/Reports/LocationCigTopSales"},
        // {isDev:true, name:"Shift Summary", to:"/Reports/ShiftSummary"},
        // {isDev:true, name:"Totalizers", to:"/Reports/Totalizers"},
        // {isDev:true, name:"POS", to:"/Reports/POSRawTransactions"},
        // {isDev:true, name:"Invoices", to:"/Reports/InvoiceRawTransactions"},
        
        // {isHR: true},
        // {title:"New Cig Pricing", isTitle:true},
        // {name:"Cig Pricing", to:"/Reports/CigPricing"},

        // {isHR: true},
        // {title:"Inventory", isTitle:true},
        // {name:"Inventory Counts", to:"/Reports/InventoryCounts"},
        // {isDev:true, name:"Inventory Pricing Old", to:"/Inventory/PricingOld"},
        // {name:"Inventory Search", to:"/Inventory/Search"},
        // {name:"Cigarette Pricing", to:"/Inventory/Pricing"},
        
        
        {isHR: true},
        {title:"💳 POS Reports", isTitle:true},
        {name:"POS Summary", to:"/Reports/POS/POSSummaryReport"},
        // {name:"Manual Transactions", to:"/Reports/POS/ManualTransactions"},

        {isHR: true},
        {title:"Shifts Data Entry", isTitle:true},
        {name:"Shifts Page", to:"/Reports/ShiftsPage"},
        {name:"Shifts Summary", to:"/Reports/ShiftsSummaryPage"},
        // {isDev:true, name:"Shifts Page Old", to:"/Reports/ShiftsPageOld"},
        // {name:"Shifts Summary Page", to:"/Reports/ShiftsPage"},
        
        // {isHR: true},
        // {title:"📞 Phone Sys", isTitle:true},
        // {name:"🐞Phone Debug", to:"/Phone/DebugPage"},
        
        // {isHR: true},
        // {title:"🚕 Operators", isTitle:true},
        // {name:"🐞Operators", to:"/Taxi/OperatorsPage"},
        // {name:"🐞Function Logging", to:"/Taxi/FunctionLoggingPage"},

        // {isHR: true},
        // {title:"🚕 Misc/Taxi", isTitle:true},
        // {name:"🌟Daily Trip Summary", to:"/Reports/Taxi/DailyTripSummary"},
        // {title:" ", isTitle:true},
        // {title:" ", isTitle:true},
        // {title:" ", isTitle:true},
        // {isHR: true},

        // {isDev:true, isHR: true},
        // {isDev:true, title:"🚕 Misc/Taxi", isTitle:true},
        // {isDev:true, name:"SQL Reports", to:"/Reports/SQL"},
        // {isDev:true, isHR: true},
        // {isDev:true, title:" Lookups", isTitle:true},
        // {isDev:true, name:"POS Transaction Lookup", to:"/Reports/POSLookup", class:"POSLookup"},
        // {isDev:true, name:"Invoice Lookup", to:"/Reports/InvoiceLookup"},
        // {isDev:true, name:"SummaryReport01", to:"/Reports/SummaryReports/SummaryReport01"},
        
        
        
      ]
    }
  },
  created: function(){
    this.navSelection = this.$route.name
  },
  watch: {
    '$route.name' : function(){
      this.navSelection = this.$route.name
    }
  }, 
  methods: {
    selectionClass: function(name){
      // this removes emoji from the name
      let _name = name.replace(/([\uE000-\uF8FF]|\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDDFF])/g, '')

      _name = _name.replace(/ /g, '')
      return this.navSelection === _name || this.navSelection === _name + 'Page' || this.navSelection === _name + 'Report' ? 'active' : '';
    }
  }
}
</script>

<style scoped>
hr {
  margin:0;
}
a {
  text-decoration: none !important;
}

.isDev{
  background-color: rgba(158, 184, 216, 0.297);
}
</style>

